import { combineReducers } from '@reduxjs/toolkit';

import {
  appSettingsSlice,
  badgesSlice,
  blogPostsSlice,
  memberSlice,
  siteSlice,
  uiSlice,
} from './slices';

export const rootReducer = combineReducers({
  member: memberSlice.reducer,
  badges: badgesSlice.reducer,
  blogPosts: blogPostsSlice.reducer,
  site: siteSlice.reducer,
  ui: uiSlice.reducer,
  appSettings: appSettingsSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
